import { Injectable, signal } from '@angular/core';
import { StorageService } from '@core/storage/storage.service';
import { CStorageKeys } from '@core/storage/storage-keys.const';

@Injectable({
  providedIn: 'root'
})
export class GuestCountService {
  private _guestCount = signal<number | undefined>(undefined);
  guestCount = this._guestCount.asReadonly();

  private _shouldAutoPrompt = true;

  constructor(private storageService: StorageService) {}

  /** Get the current guest count. */
  getGuestCount() {
    return this._guestCount();
  }

  /** Set the guest count and disable auto prompts. */
  setGuestCount(count: number) {
    this._guestCount.set(count);
    this._shouldAutoPrompt = false;
    this.setStoredGuestCount(count);
  }

  /** Clear the guest count and re-enable auto prompts. */
  clearGuestCount() {
    this._guestCount.set(undefined);
    this._shouldAutoPrompt = true;
    this.clearStoredGuestCount();
  }

  /** Check if we should prompt automatically for a guest count. */
  getShouldAutoPrompt() {
    return this._shouldAutoPrompt;
  }

  /** Set whether we should prompt automatically for a guest count. */
  setShouldAutoPrompt(shouldPrompt: boolean) {
    this._shouldAutoPrompt = shouldPrompt;
  }

  getStoredGuestCount(): number | undefined {
    const storedGuestCount = Number(this.storageService.getItem<string>(CStorageKeys.guestCount, false));
    if (isNaN(storedGuestCount)) {
      return undefined;
    }

    return storedGuestCount;
  }

  private setStoredGuestCount(guestCount: number) {
    this.storageService.setItem(CStorageKeys.guestCount, guestCount.toString(), false);
  }

  private clearStoredGuestCount() {
    this.storageService.removeItem(CStorageKeys.guestCount, false);
  }
}
